namespace poweractions_ui {
    import IController = angular.IController;

    class PowerActionsConsoleViewController implements IController {
        resized: boolean;

        constructor() { }

        $onInit(): void {
            this.onResize();
        }

        onResize(): void {
            setTimeout(() => {
                this.resized = !this.resized;
            }, 100);
        }
    }

    angular.module("com.vmware.vsphere.client.poweractions")
            .controller("PowerActionsConsoleViewController",
                  PowerActionsConsoleViewController);
}